import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { LanguagesModule } from '@sbd-doug-frontend/app/layout/common/languages/languages.module';
import { MessagesModule } from '@sbd-doug-frontend/app/layout/common/messages/messages.module';
import { NotificationsModule } from '@sbd-doug-frontend/app/layout/common/notifications/notifications.module';
import { QuickChatModule } from '@sbd-doug-frontend/app/layout/common/quick-chat/quick-chat.module';
import { SearchModule } from '@sbd-doug-frontend/app/layout/common/search/search.module';
import { ShortcutsModule } from '@sbd-doug-frontend/app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from '@sbd-doug-frontend/app/layout/common/user/user.module';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';
import { ThinLayoutComponent } from '@sbd-doug-frontend/app/layout/layouts/vertical/thin/thin.component';

@NgModule({
    declarations: [
        ThinLayoutComponent
    ],
    imports     : [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        QuickChatModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule
    ],
    exports     : [
        ThinLayoutComponent
    ]
})
export class ThinLayoutModule
{
}
